import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { AppServices } from '@src/slide/application/app-services';
import { UiDataService } from '@src/slide/domain/ui-model/service/ui-data-service';
import CanvasE2EManager from '@src/js/auto-test/canvas-e2e';
import AutoTestManager from '@src/js/auto-test';
import {
    IBaseViewableServiceLayer,
} from '@src/slide/application/entry/toc/base/service-layer/base-viewable-service-layer.interface';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

export abstract class SlideBaseAppServices extends AppServices implements ISlideBaseAppServices {
    public viewableServiceLayer: IBaseViewableServiceLayer;
    private readonly uiDataService: IUiDataService;

    protected constructor() {
        super();
        this.uiDataService = new UiDataService();
        if (ENV.IS_TEST ||  __IS_DEV__) {
            global.appServices = this;
            AutoTestManager.getInstance();
            CanvasE2EManager.getInstance().init();
        }
        this.viewableServiceLayer = this.createViewableServiceLayer();
    }

    public getUiDataService(): IUiDataService {
        return this.uiDataService;
    }

    public init(): void {
        super.init();
        this.uiDataService.init();
    }

    protected abstract createViewableServiceLayer(): IBaseViewableServiceLayer;
}
